
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Form,
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getSettings, updateSetting } from "../../store/settings/actions";
import FormEditors from "../Forms/FormEditors";


const PrivacyPolicy = (props) => {

  const dispatch = useDispatch()
 const settings = useSelector(state => state.settings.settings)
 const [privacy_policy_ar, setPrivacyPolicyAr] = useState("")
 const [privacy_policy_en, setPrivacyPolicyEn] = useState("")
 const [privacy_policy_fr, setPrivacyPolicyFr] = useState("")
 useEffect(() => {
   dispatch(getSettings())
 }, [dispatch])
 useEffect(() => {
   setPrivacyPolicyAr(settings.privacy_policy_ar)
   setPrivacyPolicyEn(settings.privacy_policy_en)
   setPrivacyPolicyFr(settings.privacy_policy_fr)
 }, [settings])
 const handleSubmit = () => {
   dispatch(
     updateSetting({
       id: settings.id ?? 1,
       privacy_policy_ar,
       privacy_policy_en,
       privacy_policy_fr,
     })
   )
 }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Privacy Policy" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4>Privacy policy</h4>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>
                  {/* 
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      return false
                    }}
                    className="custom-validation"
                  > */}
                  <Label>
                    <h4 className="card-title">English</h4>
                  </Label>

                  <FormEditors
                    value={privacy_policy_en}
                    onChange={setPrivacyPolicyEn}
                  />
                  <Label>
                    <h4 className="card-title">French</h4>
                  </Label>
                  <FormEditors
                    value={privacy_policy_fr}
                    onChange={setPrivacyPolicyFr}
                  />

                  <Label>
                    <h4 className="card-title">Arabic</h4>
                  </Label>
                  <FormEditors
                    value={privacy_policy_ar}
                    onChange={setPrivacyPolicyAr}
                  />

                  <div className="d-flex flex-wrap gap-2">
                    <Button type="button" color="primary" className="" onClick={handleSubmit}>
                      Submit
                    </Button>{" "}
                    <Button type="reset" color="secondary" className="">
                      Cancel
                    </Button>
                  </div>
                  {/* </Form> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default PrivacyPolicy
